(() => {
  const script = document.currentScript;
  const locale = script?.dataset.locale || 'it';
  const mapUrl = script?.dataset.mapUrl;
  if (!mapUrl || !['it', 'en', 'fr', 'es', 'pt', 'de'].includes(locale)) return;
  const selector = '[id^="rk"] a[href], .rk_recipe a[href], .article--content a[href]';
  fetch(mapUrl).then(response => {
    if (!response.ok) throw new Error('Recipe links unavailable');
    return response.json();
  }).then(map => {
    const localHosts = new Set([location.hostname, 'specialingredients.it', 'www.specialingredients.it']);
    function updateLinks() {
      document.querySelectorAll(selector).forEach(link => {
        const raw = (link.getAttribute('href') || '').trim();
        if (!raw || raw.startsWith('#')) return;
        let url;
        try { url = new URL(raw, location.origin); } catch { return; }
        if (!localHosts.has(url.hostname) || !['http:', 'https:'].includes(url.protocol)) return;
        let path = url.pathname.replace(/^\/(en|fr|es|pt(?:-pt)?|de)(\/|$)/i, '/');
        if (path.includes('/products/')) path = '/products/' + path.split('/products/')[1];
        let key;
        try { key = decodeURIComponent(path).toLowerCase(); } catch { return; }
        const resource = map.resources[map.aliases[key]];
        let target = resource?.paths[locale];
        if (!target && /^\/(products|collections|blogs)\//.test(path)) {
          target = (locale === 'it' ? '' : '/' + locale) + path;
        }
        if (!target) return;
        target += url.search + url.hash;
        if (link.getAttribute('href') !== target) link.setAttribute('href', target);
      });
    }
    let scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; updateLinks(); });
    }
    updateLinks();
    new MutationObserver(schedule).observe(document.body, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['href']
    });
  }).catch(() => {});
})();
